import { useState } from "react"

type ControlPagingBikeFleetProps = {
	pageIndex: number;
	pageOptions: number[];
	gotoPage: (pageIndex: number) => void;
}

 const ControlPagingBikeFleet : React.FC<ControlPagingBikeFleetProps> = ({
	pageIndex,
	pageOptions,
	gotoPage,
}) =>{
	const [pageGroupIndex, setPageGroupIndex] = useState(0)
	const pagesPerGroup = 5
	const totalPageGroups = Math.ceil(pageOptions.length / pagesPerGroup)

	const getPageGroup = () => {
		const startPageIndex = pageGroupIndex * pagesPerGroup
		const endPageIndex = Math.min(startPageIndex + pagesPerGroup, pageOptions.length)
		return [...Array(endPageIndex - startPageIndex).keys()].map((i) => startPageIndex + i)
	}

	const goToNextPageGroup = () => {
		if (pageGroupIndex < totalPageGroups - 1) {
			setPageGroupIndex(pageGroupIndex + 1)
			gotoPage(pageGroupIndex * pagesPerGroup + pagesPerGroup)
		}
	}

	const goToPreviousPageGroup = () => {
		if (pageGroupIndex > 0) {
			setPageGroupIndex(pageGroupIndex - 1)
			gotoPage(pageGroupIndex * pagesPerGroup - pagesPerGroup)
		}
	}

	return (
		<div className="flex gap-4 justify-center mt-2">
			<button onClick={goToPreviousPageGroup} disabled={pageGroupIndex === 0}>
				{"<<"}
			</button>
			{getPageGroup().map((pageNumber) => (
				<button
					key={pageNumber}
					onClick={() => gotoPage(pageNumber)}
					style={{ fontWeight: pageIndex === pageNumber ? "bold" : "normal" }}
				>
					{pageNumber + 1}
				</button>
			))}
			<button onClick={goToNextPageGroup} disabled={pageGroupIndex === totalPageGroups - 1}>
				{">>"}
			</button>
		</div>
	)
}
export default ControlPagingBikeFleet